import * as React from "react";
import GestionarSolicitudes from "screens/GestionarSolicitudes";

const MisSolicitudes = () => {
  return <GestionarSolicitudes isMias={true} />;
};

export default MisSolicitudes;
